import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Where can I go with any inquiries related to the F1 STC SAUDI ARABIAN GRAND PRIX 2025?"
      })
    }), "\n", _jsx(_components.p, {
      children: "Please contact info@saudimotorsport.com, or call 9200 21023"
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Am I allowed to take photograph at the event?"
      })
    }), "\n", _jsx(_components.p, {
      children: "Yes, but only for personal purposes - no professional footage is allowed to be captured without F1 authorisation."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "How can the customer's ticket details be changed after the ticket purchase is complete?"
      })
    }), "\n", _jsx(_components.p, {
      children: "Once the ticket purchase is complete no changes to a customer's ticket details are possible."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
